"use client";

import * as React from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";

import { cn } from "@/lib/utils";

function TooltipProvider({ delayDuration = 0, ...props }: React.ComponentProps<typeof TooltipPrimitive.Provider>) {
    return <TooltipPrimitive.Provider data-slot="tooltip-provider" delayDuration={delayDuration} {...props} />;
}

function Tooltip({ ...props }: React.ComponentProps<typeof TooltipPrimitive.Root>) {
    return (
        <TooltipProvider>
            <TooltipPrimitive.Root data-slot="tooltip" {...props} />
        </TooltipProvider>
    );
}

function TooltipTrigger({ ...props }: React.ComponentProps<typeof TooltipPrimitive.Trigger>) {
    return <TooltipPrimitive.Trigger data-slot="tooltip-trigger" {...props} />;
}

function TooltipContent({
    className,
    sideOffset = 0,
    children,
    ...props
}: React.ComponentProps<typeof TooltipPrimitive.Content>) {
    return (
        <TooltipPrimitive.Portal>
            <TooltipPrimitive.Content
                data-slot="tooltip-content"
                sideOffset={sideOffset}
                className={cn(
                    "setu:bg-primary setu:text-primary-foreground setu:animate-in setu:fade-in-0 setu:zoom-in-95 setu:data-[state=closed]:animate-out setu:data-[state=closed]:fade-out-0 setu:data-[state=closed]:zoom-out-95 setu:data-[side=bottom]:slide-in-from-top-2 setu:data-[side=left]:slide-in-from-right-2 setu:data-[side=right]:slide-in-from-left-2 setu:data-[side=top]:slide-in-from-bottom-2 setu:z-50 setu:w-fit setu:rounded-md setu:px-3 setu:py-1.5 setu:text-xs setu:text-balance",
                    className
                )}
                {...props}
            >
                {children}
                <TooltipPrimitive.Arrow className="setu:bg-primary setu:fill-primary setu:z-50 setu:size-2.5 setu:translate-y-[calc(-50%_-_2px)] setu:rotate-45 setu:rounded-[2px]" />
            </TooltipPrimitive.Content>
        </TooltipPrimitive.Portal>
    );
}

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
